import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formateSeconds'
})
export class FormateSecondsPipe implements PipeTransform {

  transform(value: number, type: string): any {
    if (type == 'absoluteHours') {
      value = value / 3600;
      const res = Math.round(value * 10) / 10;
      return res;
    }
    else if (type == 'absoluteMinutes') {
      return Math.round(value / 60) == 1 ? `${Math.round(value / 60)} min` : `${Math.round(value / 60)} mins`;
    }
    else if ( type == 'hourMinute') {
      const h = Math.floor(value / 3600);
      const hrString = (h == 1) ? ' hr' : ' hrs';
      const m = Math.floor(value % 3600 / 60);
      const mString = (m == 1) ? ' min' : ' mins';
      return `${h} ${hrString} ${m} ${mString}`;
    }
    else if ( type == 'hm') {

      const h = Math.floor(value / 3600);
      const hrString = ' h';
      const m = Math.floor(value % 3600 / 60);
      if ( m == 0 && h == 0) { return '-'; }
      const mString = m > 9 ? ' mins' : ' min';
      let str = ``;
      if (h){
        str += `${h} ${hrString} `;
      }
      if (m){
        str += `${m} ${mString}`;
      }
      return str;
    }
    else if ( type == 'HM') {

      const h = Math.floor(value / 3600);
      const hrString = ' h';
      const m = Math.floor(value % 3600 / 60);
      if ( m == 0 && h == 0) { return '-'; }
      const mString = m > 9 ? ' m' : ' m';
      let str = ``;
      if (h){
        str += `${h} ${hrString} `;
      }
      if (m){
        str += `${m} ${mString}`;
      }
      return str;
    }
    if (isNaN(value)) { value = 0; }
    const hours = Math.floor(value / 3600);
    const minutes = Math.floor((value - hours * 3600) / 60);
    const seconds = Math.floor(value - hours * 3600 - minutes * 60);
    if (type == 'printUnits') {
      return hours ? `${(hours + '').padStart(2, '0')}h ${(minutes + '').padStart(2, '0')}m ${(seconds + '').padStart(2, '0')}s` : `${(minutes + '').padStart(2, '0')}m ${(seconds + '').padStart(2, '0')}s`;
    }
    if (type == 'printShortUnits') {
      return hours ? `${(hours + '')}h ${(minutes + '')}m` : `${(minutes + '')}m`;
    }
    else { return hours ? `${(hours + '').padStart(2, '0')}:${(minutes + '').padStart(2, '0')}:${(seconds + '').padStart(2, '0')}` : `${(minutes + '').padStart(2, '0')}:${(seconds + '').padStart(2, '0')}`; }
  }

}

// export interface PipeTransform {
//   transform(value: any, ...args: any[]): any;
// }
